import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import {Tag} from 'antd'

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}
const columns = utils.columns([
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 120},
    {key:'realName', label: '教师名称',width : 120},
    {key:'courseName', label: '课程名称',width : 120},
    // {key:'title', label: '论文题目' ,width : 100},
    // {key: 'status', label:'状态' , width : 100 , render:(val)=>{
    //     if(val === 0){
    //         return <Tag color='#2db7f5'>待分配评审专家</Tag>
    //     }else if(val === 1){
    //         return <Tag color='#2db7f5'>待审核</Tag>
    //     }else if(val === 2){
    //         return <Tag color='#87d068'>审核中</Tag>
    //     }else if(val === 3){
    //         return <Tag color='#108ee9'>待复核</Tag>
    //     }else if(val === 4){
    //         return <Tag color='#87d068'>复核中</Tag>
    //     }else if(val === 5){
    //         return <Tag color='#f50'>不合格</Tag>
    //     }else if(val === 6){
    //         return <Tag color='#87d068'>合格</Tag>
    //     }
    // } },
    {key:'loginName', label: '专家登录名' ,width : 130},
    {key:'masterName', label: '评审专家' ,width : 130},
    {key:'targetName', label: '指标' ,width : 130},
    {key: 'approvalStatus', label:'状态' , width : 100 , render:(val)=>{
         if(val === 0){
            return <Tag color='#2db7f5'>待评审</Tag>
        }else {
            return <Tag color='#87d068'>已评审</Tag>
        }
    }},
    {key:'createTime', label: '发布日期' ,width : 120},
    {key:'termName', label: '学期' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/course/query/master/result?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const generate = (data)=>{
    return fetch.post('graduation/check/generate' , data)
}

const remove = (keywords) => {
    return fetch.post('graduation/check/delete' , keywords)
}

const distributeMaster = (data)=>{
    return fetch.post('graduation/check/distributeMaster' , data)
}

const getCheckMasterById = (id) => {
    return fetch.post(`graduation/assign/check/getResultMaster/${id}` , {})
}

const updateMaster = (id , params) => {
    return fetch.post(`graduation/assign/check/updateMaster/${id}` ,params)
}

const getDetailById = (id)=> {
    return fetch.get(`graduation/assign/check/getDetailById/${id}`)
}

const getById = (id)=> {
    return fetch.get(`graduation/assign/check/get/${id}`)
}

const approval = (data) => {
    return fetch.post(`graduation/check/approval` ,data)
}

const assignTask = (data) => {
    return fetch.post(`graduation/assign/check/assignTask` ,data)
}

const saveMaster = (data) => {
    return fetch.post(`graduation/assign/check/save` ,data)
}

const publicApproval = (data) => {
    return fetch.post(`graduation/assign/check/publicApproval` ,data)
}

const getMasterResultById = (id) => {
    return fetch.post(`graduation/course/get/master/result/${id}` ,{})
}

const getApprovalById = (id) => {
    return fetch.get(`graduation/assign/check/getApprovalById/${id}`)
}

const scoreCount = (params = {}) => {
    return fetch.post(`graduation/assign/check/count` ,params)
}

const saveScore = (params = {}) => {
    return fetch.post(`graduation/assign/check/insert` ,params)
}

const getApprovalDetailById = (keywords={}) => {
    return fetch.get(`graduation/assign/check/getApprovalDetailById/${keywords.id}`)
    .then(response => {
        return response.payload;
    }).then(reponseData => {
        
        const data = reponseData.data
        const meta = reponseData.meta
        const domain = {
            courseAdd: data.courseAdd,
            lessonAddress: data.lessonAddress,
            orgId: data.orgId,
            orgName: data.orgName,
            majorName : data.majorName,
            employeeId: data.employeeId,
            realName: data.realName,
            classesId: data.classesId,
            classesName: data.classesName,
            studentName : data.studentName,
            instructorName : data.instructorName,
            masterName : data.masterName,
            totalScore : data.totalScore,
            courseId: data.courseId,
            courseName: data.courseName,
            lessonNumBg: data.lessonNumBg ,
            lessonNumEnd: data.lessonNumEnd ,
            weekNum: data.weekNum ,
            weekName: data.weekName ,
            evalId: data.evalId,
            resultComment: data.resultComment,
            resultScore: data.resultScore,
            dudaoName: data.dudaoName,
            //考勤记录相关
            listenComment: data.listenComment,
            attendStudent: data.attendStudent,
            totalStudent: data.totalStudent,
            lateStudent: data.lateStudent,
            levelStudent: data.levelStudent,
            truantStudent: data.truantStudent
        }
        return {
            data: data.evalTargetList.map(evals => {
                return {
                    id: evals.id,
                    pid: evals.pid,
                    label: evals.evalName,
                    children: evals.evalSubItem.map(sub => {
                        return {
                            id: sub.id,
                            pid: sub.itemId,
                            label: sub.subName,
                            choices: sub.choices,
                            selectLabel: sub.selectLabel,
                            selectScore: sub.selectScore,
                            showScore : sub.showScore
                        }
                    })
                }
            }),
            domain: domain,
            evalExItem: meta.extParams.evalExItem,
            commentDesc : meta.extParams.commentDesc
        };
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];

        response.data.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys,
            domain: response.domain,
            evalExItem: response.evalExItem,
            commentDesc : response.commentDesc
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;

        return {
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            }),
            domain: response.domain,
            evalExItem: response.evalExItem,
            commentDesc : response.commentDesc
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;
        
        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            }),
            domain: response.domain,
            evalExItem: response.evalExItem,
            commentDesc : response.commentDesc
        };
    })
    .then(response => {
        var selects = {};

        response.data.forEach((row) => {
            
            var selectScore = response.scores[row.id].selectScore;

            var showScore = response.scores[row.id].showScore;

            var index = findSelectScore(response.scores[row.id].choices, +selectScore);
            var choice = response.scores[row.id].choices[index];
            selects[row.id] = {
                data: range(+choice.valueLow, +choice.valueHigh),
                value: +selectScore,
                index: index,
                showScore : showScore

            };
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();

        return {
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false,
            domain: response.domain,
            evalExItem: response.evalExItem,
            commentDesc : response.commentDesc
        };
    });
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const findSelectScore = (choices, selectScore) => {
    var index = -1;
    for(var i = 0 ; i < choices.length; i++ ){
        const choice = choices[i];
        const min = +choice.valueLow;
        const max = +choice.valueHigh
        if(selectScore >= min && selectScore <=max) {
            index = i;
            break;
        }
    }

    return index;
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    generate ,
    delete : remove,
    distributeMaster,
    getCheckMasterById ,
    updateMaster ,
    getDetailById ,
    approval ,
    assignTask ,
    saveMaster ,
    publicApproval,
    getApprovalById ,
    scoreCount ,
    saveScore ,
    getById ,
    getApprovalDetailById,
    getMasterResultById
}